module.exports = __webpack_public_path__ + "img/mt5-icon11.bf51e25.png";